// Condición canónica de "está facturado" para las oportunidades de Facturación.
//
// Regla 10.187: la condición de facturado debe ser IDÉNTICA en todas las vistas
// (filtro Estado, card BRUTO y numerador del % FACTURADO). Antes vivía duplicada
// dentro de useVFFiltering: el filtro/BRUTO usaba `facturanumero` O vinculación SII
// por `siiMap._byRef`, pero el numerador `totalFacturado` solo miraba `facturanumero`,
// ignorando la vinculación SII → el % FACTURADO divergía según el dataset estuviera
// filtrado por Estado o no. Centralizar acá evita que puedan volver a divergir.
//
// `getRefKeySII` reproduce EXACTAMENTE el builder `refKeyForOp` de useVFDataLoading,
// que es el que construye las keys de `siiMap._byRef` — deben coincidir carácter a
// carácter o la vinculación no se encuentra.

export const getRefKeySII = (oportunidad) => {
  if (!oportunidad) return null;
  if (oportunidad.negocio_id && oportunidad.sii_ref_index != null)
    return `negocios_carteleria:${oportunidad.negocio_id}:${oportunidad.sii_ref_index}`;
  if (oportunidad.type === "pauta") return `sales:${oportunidad.id}:`;
  if (oportunidad.type === "BTL") return `sales_btl:${oportunidad.id}:`;
  if (oportunidad.type === "contrato")
    return `sales_contratos:${oportunidad.contrato_id}:${oportunidad.mes_index ?? ""}`;
  return null;
};

// true si la oportunidad tiene factura: por número de factura (texto) O por
// vinculación SII (siiMap._byRef). Única fuente de verdad de "facturado".
export const tieneFactura = (oportunidad, siiMap) => {
  if (oportunidad?.facturanumero && String(oportunidad.facturanumero).trim() !== "") return true;
  if (!siiMap?._byRef) return false;
  const refKey = getRefKeySII(oportunidad);
  return refKey ? !!siiMap._byRef[refKey] : false;
};
